import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const HubListRBAC = {
  pageID: 'ef4172b8334ff78c1201ab912ee903c6',
  elementID: {
    BtnBulkUploadHubProduct: 'dbc1cd6464c55f3b0fc56c1c42d674b7',
    BtnBulkUploadCloudKitchenSchedule: '12892865d721242b2c009a695dfe3f43',
    BtnBulkUpdateItemPrice: 'd0944a08141daf2c461a7b6cac1d743b',
    BtnAddProductHub: 'aea88ca6c2ad1f6d4ac3d2e14fa50201',
    BtnViewStockTrailing: '2edd3edf96ed2562152408bdf0b7c085',
    BtnViewCloudKitchenSchedule: 'e90fe102a58e2e80e7f594572ad101d3',
    BtnUpdateModalCloudKitchenSchedule: '7d96e1b67c37f130473bdba19914b1fe',
    BtnBulkUploadInventoryTransfer: '58905397bdd04ae889862b1a9fbb19ae',
    BtnUpdateItemPrice: '3423f797c2c68d94f25d3767fc693367',
    BtnViewStockProductDetail: 'e3805a8c2e15342c328a7ed4f3cace11',
    BtnUpdateStatusProductHub: '515c878d4e90c9b77b6b11e8244e0d45',
  },
} as const

export const useRBACHubListPage = createUseRBAC(HubListRBAC.elementID)
export type UseRBACHubListPageType = ReturnType<typeof useRBACHubListPage>
